import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import css_248z from './styles/social-share-block.scss.js';
import '../../atoms/buttons/generic-button2.0/index.js';

class SocialShareBlock extends s {
    constructor() {
        super();
        this.title = 'Start sharing your stories';
        this.items = [];
        this.titleId = '';
        this.titleId = `social-share-title-${crypto.randomUUID()}`;
    }
    static renderButton(item) {
        const ariaLabel = item.ariaLabel || item.altText || '';
        return $ `<li class="social-share__item"><generic-button-updated class="social-share__button" .styleType="${'light'}" .color="${'cloud'}" .type="${'primary'}" .appearance="${'icon-circle'}" .customSvgUrl="${item.image}" .href="${item.link}" .target="${'_blank'}" .ariaList="${{ 'aria-label': ariaLabel }}" .isNoFollow="${true}"></generic-button-updated></li>`;
    }
    render() {
        return $ `<div class="social-share" role="region" aria-labelledby="${this.titleId}"><h2 id="${this.titleId}" class="social-share__title">${o(this.title)}</h2><ul class="social-share__list">${this.items.map(item => SocialShareBlock.renderButton(item))}</ul></div>`;
    }
}
SocialShareBlock.styles = css_248z;
__decorate([
    e({ type: String })
], SocialShareBlock.prototype, "title", void 0);
__decorate([
    e({ type: Array })
], SocialShareBlock.prototype, "items", void 0);
__decorate([
    t()
], SocialShareBlock.prototype, "titleId", void 0);
customElements.define('social-share-block', SocialShareBlock);

export { SocialShareBlock };
